<mat-toolbar class="mat-elevation-z8">
  {{ 'VEHICLE_KEY_SAFE.EDIT_TITLE' | transloco }}
</mat-toolbar>

<!-- <div *ngIf="isLoading" class="spinner">
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div> -->

<mat-dialog-content class="mt-3">
  @if (editVehicleKeySafeForm) {
    <form [formGroup]="editVehicleKeySafeForm">
      <!-- <mat-form-field class="mb-2 w-100" appearance="outline">
      <mat-label>
        {{'VEHICLE_KEY_SAFE.SAFE_NUMBER' | transloco}}
      </mat-label>
      <input matInput min="1" max="1100" type="number" formControlName="safeNumber" />
      <mat-error *ngIf="!editVehicleKeySafeForm.controls.safeNumber.valid && editVehicleKeySafeForm.controls.safeNumber.touched">
        {{'VEHICLE_KEY_SAFE.SAFE_NUMBER' | transloco}}
      </mat-error>
    </mat-form-field> -->
    <!-- <mat-form-field class="" appearance="outline">
    <mat-label>
      {{ 'VEHICLE_KEY_SAFE.SAFE_STATUS' | transloco }}
    </mat-label>
    <mat-select formControlName="safeStatus">
      <mat-option value="">
        None
      </mat-option>
      <mat-option *ngFor="let status of statusOptions" [value]="status.value">
        {{ status.name }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
  <!-- <mat-form-field class="" appearance="outline" (click)="safePickupDate.open()">
  <mat-label>
    {{ 'VEHICLE_KEY_SAFE.SAFE_PICKUP_DATE' | transloco }}
  </mat-label>
  <input matInput class="date-input" [matDatepicker]="safePickupDate" formControlName="safePickupDate" />
  <mat-datepicker-toggle matSuffix [for]="safePickupDate"></mat-datepicker-toggle>
  <mat-datepicker touchUi #safePickupDate></mat-datepicker>
  <mat-icon class="date-cancel-icon" matDatepickerToggleIcon
  (click)="clearDate($event, editVehicleKeySafeForm.controls['safePickupDate'])">clear</mat-icon>
</mat-form-field> -->
<!-- <mat-form-field class="mb-2 w-100" appearance="outline">
<mat-label>
  {{'VEHICLE_KEY_SAFE.AIR_TAG_NUMBER' | transloco}}
</mat-label>
<input matInput min="1" max="10" type="number" formControlName="airTagNumber" />
<mat-error *ngIf="!editVehicleKeySafeForm.controls.airTagNumber.valid && editVehicleKeySafeForm.controls.airTagNumber.touched">
  {{'VEHICLE_KEY_SAFE.AIR_TAG_NUMBER' | transloco}}
</mat-error>
</mat-form-field> -->
<!-- <mat-form-field class="" appearance="outline">
<mat-label>
  {{ 'VEHICLE_KEY_SAFE.AIR_TAG_STATUS' | transloco }}
</mat-label>
<mat-select formControlName="airTagStatus">
  <mat-option value="">
    {{ 'VEHICLE_KEY_SAFE.NONE' | transloco }}
  </mat-option>
  <mat-option *ngFor="let status of statusOptions" [value]="status.value">
    {{ status.name }}
  </mat-option>
</mat-select>
</mat-form-field> -->
<mat-form-field class="" appearance="outline">
  <mat-label>
    {{ 'AIR_TAG.LINKED_AIRTAG' | transloco }}
  </mat-label>
  <mat-select formControlName="airTagId">
    @for (airTag of data.airTagList; track airTag) {
      <mat-option [value]="airTag.id">
        {{ airTag.name }}
      </mat-option>
    }
  </mat-select>
  @if (!editVehicleKeySafeForm.controls.airTagId.valid && editVehicleKeySafeForm.controls.airTagId.touched) {
    <mat-error>
      {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('AIR_TAG.LINKED_AIRTAG' | transloco) } }}
    </mat-error>
  }
</mat-form-field>
<mat-form-field class="" appearance="outline">
  <mat-label>
    {{ 'AIR_TAG.LINKED_ADDITIONAL_SERVICE' | transloco }}
  </mat-label>
  <mat-select formControlName="selectedAdditionalService">
    @for (additionalService of data.additionalServices; track additionalService) {
      <mat-option [value]="additionalService.id">
        {{ additionalService.name | translateAttribute }}
      </mat-option>
    }
  </mat-select>
  @if (!editVehicleKeySafeForm.controls.selectedAdditionalService.valid && editVehicleKeySafeForm.controls.selectedAdditionalService.touched) {
    <mat-error>
      {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('AIR_TAG.LINKED_ADDITIONAL_SERVICE' | transloco) } }}
    </mat-error>
  }
</mat-form-field>
@if (editVehicleKeySafeForm.controls.additionalServiceCompleted) {
  <mat-form-field  class="" appearance="outline">
    <mat-label>
      {{ 'AIR_TAG.IS_ADDITIONAL_SERVICE_COMPLETED' | transloco }}
    </mat-label>
    <mat-select formControlName="additionalServiceCompleted">
      <mat-option value="true">
        {{ 'YES' }}
      </mat-option>
      <mat-option value="false">
        {{ 'NO' }}
      </mat-option>
    </mat-select>
    @if (!editVehicleKeySafeForm.controls.additionalServiceCompleted.valid && editVehicleKeySafeForm.controls.additionalServiceCompleted.touched) {
      <mat-error>
        {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('AIR_TAG.IS_ADDITIONAL_SERVICE_COMPLETED' | transloco) } }}
      </mat-error>
    }
  </mat-form-field>
}
<!-- <mat-form-field class="" appearance="outline" (click)="airTagAttachDate.open()">
<mat-label>
  {{ 'VEHICLE_KEY_SAFE.AIR_TAG_ATTACH_DATE' | transloco }}
</mat-label>
<input matInput class="date-input" [matDatepicker]="airTagAttachDate" formControlName="airTagAttachDate" />
<mat-datepicker-toggle matSuffix [for]="airTagAttachDate"></mat-datepicker-toggle>
<mat-datepicker touchUi #airTagAttachDate></mat-datepicker>
<mat-icon class="date-cancel-icon" matDatepickerToggleIcon
(click)="clearDate($event, editVehicleKeySafeForm.controls['airTagAttachDate'])">clear</mat-icon>
</mat-form-field> -->
</form>
}

</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <!-- pricingForm.dirty -->
  <button mat-raised-button color="primary" [disabled]="editVehicleKeySafeForm.invalid || isLoading"
    (click)="submitForm()">
    <span>
      @if (!data.currentAirTag) {
        {{'AIR_TAG.TAG' | transloco }}
      }
      @if (data.currentAirTag) {
        {{'AIR_TAG.UNTAG' | transloco }}
      }
    </span>
  </button>
  <button mat-button mat-dialog-close [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>
